import React from "react";
import EmailField from "../../sharedComponents/email/EmailField";
import { observer } from "mobx-react";
import { ClientModel } from "../../../helpers/client";

interface EmailProps {
    client: ClientModel;
}

export function Email(props: EmailProps) {
    const client = props.client;

    return (
        <div className="email">
            <div className="question-answer-container">
                <div className="question">Adres e-mail</div>
                {renderEmail()}
            </div>
        </div>
    );

    function renderEmail() {
        return (
            <div className="email-container">
                <EmailField
                    client={client}
                    />
            </div>);
    }
}

export default observer(Email);
